var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgRoSmeIcon = function SvgRoSmeIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "url(#ro-sme-icon_svg__a)",
    rx: 7.2
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M20.386 15.31c-.34-.29-.84-.578-1.495-.842l.484-.601c1.437.611 2.304 1.402 2.304 2.266 0 1.939-4.37 3.511-9.76 3.511s-9.76-1.572-9.76-3.511c0-.832.803-1.596 2.146-2.198l.486.598c-.58.246-1.028.511-1.34.776-.396.338-.51.617-.51.824s.114.486.51.823c.398.338 1.016.676 1.847.975 1.656.595 3.996.98 6.62.98s4.966-.385 6.622-.98c.83-.3 1.449-.637 1.846-.975s.51-.617.51-.823c0-.207-.113-.486-.51-.824",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.947 6.697a4.172 4.172 0 0 1 3.305 6.72h.001l-2.926 3.796a.48.48 0 0 1-.759 0l-2.925-3.795a4.173 4.173 0 0 1 3.304-6.72m.225 3.934v2.432l.95-.573 1.143-.656v-2.4zm-2.513 1.203 2.177 1.2v-2.401l-2.177-1.2zm.204-2.676 2.122 1.225 2.122-1.225-.962-.555-1.16-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.173 4.412a4.173 4.173 0 0 1 3.305 6.72l-2.926 3.795a.48.48 0 0 1-.758 0l-1.028-1.333c.669-.911.967-1.995.908-3.06l.388.214v-2.4l-1.97-1.086s-.99-.575-1.49-.851c.166-.265.391-.548.62-.777a4.16 4.16 0 0 1 2.95-1.222m.224 3.933v2.433l.949-.573 1.144-.656v-2.4zm-2.308-1.472 2.121 1.225 2.121-1.225-.961-.555-1.16-.67zM6.532 4.356c1.068 0 2.136.408 2.95 1.223.241.24.48.54.65.82 0 0-.823.422-1.283.694L6.756 8.29v2.433l.473-.287a4.7 4.7 0 0 0 .823 2.956l-1.14 1.48a.48.48 0 0 1-.759 0l-2.925-3.795a4.173 4.173 0 0 1 3.304-6.72M4.244 9.493l2.177 1.2V8.292l-2.177-1.2zm.204-2.676L6.57 8.042l2.12-1.225-.961-.555-1.16-.67z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "ro-sme-icon_svg__a",
    x1: 12.032,
    x2: 11.3,
    y1: -3.675,
    y2: 26.3,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.073,
    stopColor: "#FC9113"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.575,
    stopColor: "#FB6514"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FB530F"
  })))));
};
export default SvgRoSmeIcon;